import i18n from '@/i18n'
import Paperwork from './paperwork'
import Learning from './learning'
import Landing from './landing'
import MyFirstDay from './myFirstDay'
import MyFirstDayCN from './myFirstDayCN'
import MyFirstDayHK from './myFirstDayHK'
import MyFirstDayTW from './myFirstDayTW'
import MyFirstDayGCR from './myFirstDayGCR'
import PaperworkHome from './paperworkHome'
import Nespresso from './nespresso'

export default [
  {
    name: 'onboardingNestleIndex',
    path: '/onboarding/:invitationId/nestle/landing',
    component: Landing,
    meta: {
      title: i18n.t('onboarding.nestle.landingPage.title')
    }
  },
  {
    name: 'onboardingNestlePaperwork',
    path: '/onboarding/:invitationId/nestle/paperwork/:questionnaireId',
    component: Paperwork,
    meta: {
      title: i18n.t('onboarding.nestle.paperworkTitle')
    }
  },
  {
    name: 'onboardingNestleLearning',
    path: '/onboarding/:invitationId/nestle/learning',
    component: Learning,
    meta: {
      title: i18n.t('onboarding.nestle.learningPage.learning')
    }
  },
  {
    name: 'onboardingNestleMyFirstDay',
    path: '/onboarding/:invitationId/nestle/my-first-day',
    component: MyFirstDay,
    meta: {
      title: i18n.t('onboarding.nestle.myFirstDayPage.title')
    }
  },
  {
    name: 'onboardingNestleMyFirstDayCn',
    path: '/onboarding/:invitationId/nestle/my-first-day-cn',
    component: MyFirstDayCN,
    meta: {
      title: i18n.t('onboarding.nestle.myFirstDayPage.title')
    }
  },
  {
    name: 'onboardingNestleMyFirstDayHk',
    path: '/onboarding/:invitationId/nestle/my-first-day-hk',
    component: MyFirstDayHK,
    meta: {
      title: i18n.t('onboarding.nestle.myFirstDayPage.title')
    }
  },
  {
    name: 'onboardingNestleMyFirstDayTw',
    path: '/onboarding/:invitationId/nestle/my-first-day-tw',
    component: MyFirstDayTW,
    meta: {
      title: i18n.t('onboarding.nestle.myFirstDayPage.title')
    }
  },
  {
    name: 'onboardingNestleMyFirstDayGcr',
    path: '/onboarding/:invitationId/nestle/my-first-day-gcr',
    component: MyFirstDayGCR,
    meta: {
      title: i18n.t('onboarding.nestle.myFirstDayPage.title')
    }
  },
  {
    name: 'onboardingNestlePaperworkHome',
    path: '/onboarding/:invitationId/nestle/paperwork-home',
    component: PaperworkHome,
    meta: {
      title: i18n.t('onboarding.nestle.paperworkHome.title')
    }
  },
  {
    name: 'onboardingNestleNespresso',
    path: '/onboarding/:invitationId/nestle/nespresso',
    component: Nespresso,
    meta: {
      title: i18n.t('onboarding.nestle.nespresso.title')
    }
  }
]
